import store from './index'
import { getStorageAdminUser,getStorageCurrentMenu,setStorageUserRoleId } from '@/utils/store'
export default function () {
  return new Promise((resolve) => {
    if (window.location.href.indexOf('/login') == -1) {
      store.dispatch('app/setCurrentMenu', getStorageCurrentMenu())
      let id
      id = getStorageAdminUser().role_id;
      if(id){
        setStorageUserRoleId(id)
        store.dispatch('app/setUserRole', {id, isLoad: true}).then(res => {
          resolve(res)
        })
      }else{
        resolve(1)
      }
    } else {
      resolve(1)
    }
  })
}